import { jsx as _jsx } from "react/jsx-runtime";
import { FifoLogger } from 'fifo-logger';
import { createContext, useContext, useRef, useMemo, useState, useCallback, useEffect, } from 'react';
import { usePreferences } from './PreferencesContext';
export const LoggerContext = createContext(null);
export function useLogger() {
    const context = useContext(LoggerContext);
    if (!context) {
        throw new Error('Logger context was not found');
    }
    return context;
}
export function LoggerProvider({ children }) {
    const { current: { general: { loggingLevel }, }, } = usePreferences();
    const [lastReadLogId, setLastLogId] = useState(0);
    const [logsHistory, setLogsHistory] = useState([]);
    const loggerRef = useRef(new FifoLogger({
        onChange: (log, logs) => {
            setLogsHistory(logs.slice());
        },
    }));
    useEffect(() => {
        if (loggingLevel) {
            loggerRef.current.setLevel(loggingLevel);
        }
    }, [loggingLevel]);
    const markAsRead = useCallback(() => {
        if (logsHistory.length > 0) {
            const id = logsHistory[logsHistory.length - 1].id;
            setLastLogId(id);
        }
    }, [logsHistory]);
    const loggerState = useMemo(() => {
        return {
            logger: loggerRef.current,
            logsHistory,
            markAsRead,
            lastReadLogId,
        };
    }, [lastReadLogId, logsHistory, markAsRead]);
    return (_jsx(LoggerContext.Provider, { value: loggerState, children: children }));
}
